/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Filter, hooks as adcHooks, TutorialTooltip } from '@adc/ui-adc'
import { track } from '@adc/analytics'
import classnames from 'classnames/bind'
import { authTypes } from '../../constants/statics'
import { SaveSearchModal } from '../redesign/saveSearchModal'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const getSaveSearchButtonLabel = (isSaved, smallButtons) => {
  let saveSearchButtonLabel = isSaved ? 'Saved Search' : 'Save Search'
  if (smallButtons) saveSearchButtonLabel = isSaved ? 'Saved' : 'Save'
  return saveSearchButtonLabel
}

const FancyNewFilters = ({
  user,
  actions,
  data,
  modals,
  onSaveSearch,
  savedSearch,
  featureFlags,
  hideClearButton = false,
}) => {
  const breakpoint = adcHooks.useBreakpoints()
  const smallButtons = breakpoint === 'tablet' || breakpoint === 'mobile'

  const signup = () =>
    modals.open('authentication', { authInitialActive: authTypes.SIGNUP })

  const { containerRef, extraButtonsRef, visibleItems, filterButtonRefs } =
    adcHooks.useFilterButtons({
      definitions: data.filtersData.filterDefinitions,
      data: data.filtersData.filterViewModels,
    })

  const extraButtonsStyle = { minWidth: smallButtons ? 70 : 130 }

  return (
    <div
      className={cx('fancy-new-filters-container')}
      data-elm-id='all_filters'
      ref={containerRef}
    >
      {visibleItems.map(def => (
        <div
          key={def.name}
          onClick={
            def.name === 'moreFilters'
              ? () => track('srp-filters-button-click')
              : undefined
          }
        >
          <Filter
            data={data.filtersData.filterViewModels[def.name]}
            definition={def}
            elmId={`${def.name}_filter`}
            filterButtonRef={filterButtonRefs?.current?.[def.name]}
            isLoading={data?.isLoading}
            resultsAmount={data?.listings?.total_count}
            className={cx({
              'more-filters-button': def.name === 'moreFilters',
            })}
            onChange={(key, value) =>
              actions.onFancyFilterChange(def, key, value)
            }
            onReset={(key, value) =>
              actions.onFancyFilterReset(def, key, value)
            }
          />
        </div>
      ))}
      <div ref={extraButtonsRef} className={cx('extra-buttons')}>
        <TutorialTooltip
          tutorial={5}
          position='bottom right'
          mobilePosition='bottom center'
          nextButtonContent={`Let's Get Started`}
          elmId='notify_me_tutorial'
          header='Never Miss a Listing'
          content='We’ll send you new properties that match your search.'
          handleNext={signup}
        >
          {featureFlags['fe.resi.enable-srp-saved-search-redesign-2025'] ? (
            <SaveSearchModal data={data} user={user} />
          ) : (
            <Button
              disabled={savedSearch.isSearchSaved}
              elmId='filters_save_search'
              onClick={onSaveSearch}
              role='primary'
              style={extraButtonsStyle}
            >
              {getSaveSearchButtonLabel(
                savedSearch.isSearchSaved,
                smallButtons
              )}
            </Button>
          )}
        </TutorialTooltip>
        {!hideClearButton && (
          <Button
            elmId='filters_clear_filters'
            onClick={actions.onFancyFilterResetAll}
            onMouseUp={e => e.currentTarget.blur()}
            role='secondary'
            style={extraButtonsStyle}
          >
            {smallButtons ? 'Clear' : 'Clear Filters'}
          </Button>
        )}
      </div>
    </div>
  )
}

FancyNewFilters.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  modals: PropTypes.any.isRequired,
  onSaveSearch: PropTypes.func.isRequired,
  featureFlags: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  savedSearch: PropTypes.bool,
  hideClearButton: PropTypes.bool,
}

export default FancyNewFilters
